@if (quickOrder$ | async; as quickorder) {
<div class="container-fluid">
  <div class="quickorder-layout">
    <div class="row">
      <div class="col-md-12">
        <div class="list-header">
          <div class="quickorder-heading">
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <div class="row">
                  <div class="col-md-2 list-header-item">
                    {{ 'dias.quickorder.page.add.products.line' | translate }}
                  </div>
                  <div class="col-md-6 list-header-item">{{ 'dias.quickorder.page.product.id' | translate }}</div>
                  <div class="col-md-3 list-header-item no-seperator quantity-input">
                    {{ 'quickorder.page.product.quantity' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-lg-8 col-md-7">
                <div class="row">
                  <div class="col-md-4 col-lg-6 list-header-item">
                    {{ 'dias.quickorder.page.add.products.description' | translate }}
                  </div>
                  <div class="col-md-3 col-lg-2 list-header-item">
                    {{ 'dias.quickorder.page.add.products.each' | translate }}
                  </div>
                  <div class="col-md-2 list-header-item">
                    {{ 'dias.quickorder.page.add.products.total' | translate }}
                  </div>
                  <div class="col-md-3 col-lg-2 position-relative list-header-item pt-0">
                    <button type="button" class="select-all-btn w-100 border-0" (click)="selectAll()">
                      {{ 'dias.quickorder.page.add.products.SelectAll' | translate }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary w-100"
                      (click)="DeleteModelItems()"
                      [disabled]="isDeleteButtonDesabled"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (this.model?.length > 0) {
    <div class="row">
      <div class="col-lg-12 p-0">
        <div class="quickorder-body">
          @for (field of field?.fieldGroup; track field; let i = $index) {
          <div
            class="row mb-3"
            [attr.data-testing-id]="'quickorder-line-' + i"
            ishProductContext
            [(quantity)]="model[i].quantity"
            [configuration]="{ quantity: true }"
            #quickOrderItemRow
          >
            <div class="col-lg-4 col-md-5">
              <div class="row">
                <div class="col-1 col-md-2 py-2">{{ i + 1 }}</div>
                <div class="quickorder-formly-field pr-2 col-7 col-md-6">
                  <formly-field [field]="field" />
                </div>
                <custom-quick-order-quantity
                  [focus]="i === this.lastUpdatedSKUIndex && quickorder.noOfItems > 0 && !quickorder.errors"
                  [lineItemID]="model[i].itemLineId"
                  (quantityUpdatedLineItemID)="updateQuantityUpdatedLineItemID($event)"
                  class="col-4 col-md-2 quickorder-line-item"
                />
              </div>
            </div>
            <custom-product-loading />
            <div class="col-lg-8 col-md-7 d-none d-md-inline-block" [hidden]="!model[i].itemLineId">
              <div class="row">
                @if (model[i].productName) {
                <div class="col-md-4 col-lg-6 mt-lg-3 quickorder-description">
                  <!-- <p>{{ model[i].productName }}</p> -->
                  <!-- <ish-product-name></ish-product-name> -->
                  <div (click)="openQuickView(model[i].productSKU)" (keydown)="openQuickView(model[i].productSKU)">
                    <div>
                      <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                      {{ model[i].productName }}
                    </div>
                  </div>
                </div>
                } @if (model[i].eachPrice) {
                <div class="col-md-3 mt-lg-3 col-lg-2">
                  {{ model[i].eachPrice | ishPrice }}
                </div>
                } @if (model[i].totalPrice) {
                <div class="col-md-2 mt-lg-3">
                  {{ model[i].totalPrice | ishPrice }}
                </div>
                } @if (model[i].productName) {
                <div class="col-md-3 col-lg-2 mt-lg-3 text-center">
                  <input
                    #deleteCheckBox
                    type="checkbox"
                    [checked]="model[i].selected"
                    (change)="model[i].selected = deleteCheckBox.checked; disableDeleteButton()"
                  />
                </div>
                }
              </div>
            </div>
          </div>
          }
          <div class="section quickorder-add-to-cart">
            <div class="row">
              <div class="col-lg-12">
                <div class="row mt-3">
                  <div class="col-3">
                    @if (basketMaxSize$ | async; as basketMaxSize) {
                    <div>
                      @if (field?.fieldGroup.length + 1 <= basketMaxSize) {
                      <a [routerLink]="[]" (click)="addMultipleRows(props?.numberMoreRows)">{{
                        'dias.quick.order.add.more.parts.text' | translate
                      }}</a>
                      }
                    </div>
                    }
                  </div>
                  <div class="col-5">
                    <div class="font-weight-bold text-left">
                      @if (freeFreightThreshold$ | async; as freeFreightThreshold) {
                      {{ 'dias.quickorder.free_shipping.threshold.text' | translate : { '0': freeFreightThreshold } }}
                      } @else {
                      {{ 'dias.quickorder.free_shipping.text' | translate }}
                      }
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="row">
                      <div class="col-8 font-weight-bold text-center">
                        {{ 'dias.quickorder.page.add.products.QuickOrderTotal' | translate }} :
                      </div>
                      <div class="col-3">
                        {{ quickorder.quickOrderTotal | ishPrice }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
} @if (loading$ | async) {
<ish-loading />
}
